module.exports = __webpack_public_path__ + "img/clean_precheck_4.13b8974d.svg";